import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo, useCallback } from 'react';
import { createUseStyles, Icon } from 'hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from "../../../lib/Web5Context";
import SectionList from "../../../components/SectionList";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ErrorList');
const warningIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                fill=#edde83
                fillRule="evenodd"
            />
        </svg>`;
const errorIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2L1 21h22M12 6l7.53 13H4.47M11 10v4h2v-4m-2 6v2h2v-2" fill="#f04540" fill-rule="evenodd"></path></svg>`;
const ErrorList = _ref => {
  let {
    errors,
    setErrorMessage,
    warnings
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const classNames = useMemo(() => (isDisabled, className) => {
    return classnames({
      [classes.iconDisabled]: isDisabled
    }, className);
  }, [classes.iconDisabled]);
  const errorList = useMemo(() => {
    let finalErrors = [];
    let finalWarnings = [];
    if (errors) finalErrors = errors.map((el, index) => _objectSpread(_objectSpread({}, el), {}, {
      error: t(el.error, [el.value || '']),
      id: `${index}-${el.row}`
    }));
    if (warnings) finalWarnings = warnings.map((el, index) => _objectSpread(_objectSpread({}, el), {}, {
      isWarning: true,
      error: t(el.error, [el.value || '']),
      id: `${el.row}-${index}`
    }));
    return [...finalWarnings, ...finalErrors];
  }, [errors, warnings, t]);
  const actions = useMemo(() => {
    return [row => {
      const isDisabled = !(row !== null && row !== void 0 && row.error);
      const onClick = isDisabled ? null : () => setErrorMessage(true, row);
      return {
        icon: /*#__PURE__*/React.createElement(Icon, {
          className: classNames(isDisabled, 'imports-row__viewError-btn'),
          onClick: onClick,
          name: "visibilityOn"
        }),
        tooltip: {
          content: t('cfm_action_read_error_message')
        }
      };
    }];
  }, [classNames, setErrorMessage, t]);
  const getAvatarSvg = useCallback(data => data.isWarning ? warningIcon : errorIcon, []);
  const listProps = useMemo(() => {
    return {
      className: classes.errorList,
      rows: errorList,
      actions: actions,
      columns: [{
        field: 'row',
        headerName: t('cfm_label_excel_row_number'),
        resizable: false,
        width: 200
      }, {
        field: 'name',
        headerName: t('cfm_label_column_name'),
        resizable: false
      }, {
        field: 'error',
        headerName: t('cfm_label_description'),
        resizable: false,
        cellRenderer: 'avatarCell',
        cellRendererParams: {
          imageSize: 'small',
          useTooltip: true,
          isSquared: true,
          innerMethods: {
            getAvatarSvg: getAvatarSvg
          }
        }
      }],
      options: {
        suppressRowHoverHighlight: true,
        rowHeight: 40
      }
    };
  }, [classes.errorList, errorList, actions, t, getAvatarSvg]);
  return /*#__PURE__*/React.createElement(SectionList, _extends({
    id: "error-list"
  }, listProps));
};
export default /*#__PURE__*/memo(ErrorList);